/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown> }} Onboarding_V1_Username_PreservedInputs */

const en_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We kept your username: ${i?.username}.`)
};

const de_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir haben Ihren Benutzernamen beibehalten: ${i?.username}.`)
};

const pt_br2_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mantivemos seu nome de usuário: ${i?.username}.`)
};

const tr_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kullanıcı adınızı koruduk: ${i?.username}.`)
};

const zh_cn2_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们保留了您的用户名：${i?.username}。`)
};

const zh_hk2_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我們保留了你的用戶名稱：${i?.username}。`)
};

const ko_kr2_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`기존 사용자 이름을 유지했습니다: ${i?.username}.`)
};

const ru_ru2_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мы сохранили ваше имя пользователя: ${i?.username}.`)
};

const es_419_onboarding_v1_username_preserved = /** @type {(inputs: Onboarding_V1_Username_PreservedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conservamos tu nombre de usuario: ${i?.username}.`)
};

/**
* | output |
* | --- |
* | "We kept your username: {username}." |
*
* @param {Onboarding_V1_Username_PreservedInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_preserved = /** @type {((inputs: Onboarding_V1_Username_PreservedInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_PreservedInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_preserved(inputs)
	if (locale === "de") return de_onboarding_v1_username_preserved(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_preserved(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_preserved(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_preserved(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_preserved(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_preserved(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_preserved(inputs)
	return es_419_onboarding_v1_username_preserved(inputs)
});